"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatScore = exports.toPercentage = exports.toSI = exports.significantDigits = void 0;
const SI_PREFIXES_CENTER_INDEX = 8;
const SI_MIN_DIGITS = 2;
const siPrefixes = [
    'y',
    'z',
    'a',
    'f',
    'p',
    'n',
    'μ',
    'm',
    '',
    'k',
    'M',
    'G',
    'T',
    'P',
    'E',
    'Z',
    'Y',
];
function significantDigits(number, minDigits = 2) {
    const min = Math.pow(10, SI_MIN_DIGITS);
    const digits = Math.max(0, Math.floor(Math.log10(min / number)));
    return number.toFixed(digits);
}
exports.significantDigits = significantDigits;
// Source: https://gist.github.com/cho45/9968462
function toSI(number) {
    if (number === 0)
        return number.toString();
    const EXP_STEP_SIZE = 3;
    const base = Math.floor(Math.log10(Math.abs(number)));
    const siBase = (base < 0 ? Math.ceil : Math.floor)(base / EXP_STEP_SIZE);
    const prefix = siPrefixes[siBase + SI_PREFIXES_CENTER_INDEX];
    // return number as-is if no prefix is available
    if (siBase === 0)
        return number.toFixed(0);
    // We're left with a number which needs to be devided by the power of 10e[base]
    // This outcome is then rounded two decimals and parsed as float to make sure those
    // decimals only appear when they're actually requird (10.0 -> 10, 10.90 -> 19.9, 10.01 -> 10.01)
    const baseNumber = parseFloat(significantDigits(number / Math.pow(10, siBase * EXP_STEP_SIZE), SI_MIN_DIGITS));
    return `${baseNumber}${prefix}`;
}
exports.toSI = toSI;
function toPercentage(number) {
    return `${(number * 100).toFixed(0)}%`;
}
exports.toPercentage = toPercentage;
function formatScore(score) {
    // Format a float between 0 and 1 to an int between 1 and 10
    return Math.ceil(score * 9 + 1);
}
exports.formatScore = formatScore;
//# sourceMappingURL=fmt.js.map